import { render, staticRenderFns } from "./RDAUNS.vue?vue&type=template&id=5171bee1&scoped=true&"
import script from "./RDAUNS.vue?vue&type=script&lang=js&"
export * from "./RDAUNS.vue?vue&type=script&lang=js&"
import style0 from "./RDAUNS.vue?vue&type=style&index=0&id=5171bee1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5171bee1",
  null
  
)

export default component.exports